<template>
    <div
        class="
          fixed inset-0 isolate z-[9999] flex items-end -mb-8 font-caption

          lg:mb-0 lg:items-center

          justify-center bg-black/50
        "
        v-if="isOpen"
        @click.prevent="closeModal"
    >
        <slot />
    </div>
</template>

<script>
    export default {
        props: {
            isOpen: {
                type: Boolean,
                required: true,
            },
        },

        methods: {
            closeModal() {
                this.$emit('close');
            },
        },
    };
</script>
